function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "100%",
  x2: "71.5092711%",
  y2: "8.62486884%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E38E0B",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD934",
  offset: "44.8925217%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFFEE9",
  offset: "100%"
})), /*#__PURE__*/React.createElement("circle", {
  id: "path-2",
  cx: 50,
  cy: 50,
  r: 48
}), /*#__PURE__*/React.createElement("filter", {
  x: "-5.2%",
  y: "-5.2%",
  width: "110.4%",
  height: "110.4%",
  filterUnits: "objectBoundingBox",
  id: "filter-3"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.5,
  in: "SourceAlpha",
  result: "shadowBlurInner1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 1,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1   0 0 0 0 0.811764706   0 0 0 0 0.0784313725  0 0 0 1 0",
  type: "matrix",
  in: "shadowInnerInner1",
  result: "shadowMatrixInner1"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 2,
  operator: "erode",
  in: "SourceAlpha",
  result: "shadowSpreadInner2"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  in: "shadowSpreadInner2",
  result: "shadowBlurInner2"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "shadowBlurInner2",
  result: "shadowOffsetInner2"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner2",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.95   0 0 0 0 0.6175   0 0 0 0 0  0 0 0 1 0",
  type: "matrix",
  in: "shadowInnerInner2",
  result: "shadowMatrixInner2"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixInner1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixInner2"
}))), /*#__PURE__*/React.createElement("ellipse", {
  id: "path-4",
  cx: 39,
  cy: 6,
  rx: 4,
  ry: 6
}), /*#__PURE__*/React.createElement("filter", {
  x: "-37.5%",
  y: "-25.0%",
  width: "175.0%",
  height: "150.0%",
  filterUnits: "objectBoundingBox",
  id: "filter-5"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  in: "SourceAlpha",
  result: "shadowBlurInner1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.768627451   0 0 0 0 0.396078431   0 0 0 0 0.00392156863  0 0 0 1 0",
  type: "matrix",
  in: "shadowInnerInner1",
  result: "shadowMatrixInner1"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 1,
  operator: "erode",
  in: "SourceAlpha",
  result: "shadowSpreadInner2"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5,
  in: "shadowSpreadInner2",
  result: "shadowBlurInner2"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "shadowBlurInner2",
  result: "shadowOffsetInner2"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner2",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
  type: "matrix",
  in: "shadowInnerInner2",
  result: "shadowMatrixInner2"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixInner1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixInner2"
}))), /*#__PURE__*/React.createElement("ellipse", {
  id: "path-6",
  cx: 4,
  cy: 6,
  rx: 4,
  ry: 6
}), /*#__PURE__*/React.createElement("filter", {
  x: "-25.0%",
  y: "-16.7%",
  width: "150.0%",
  height: "133.3%",
  filterUnits: "objectBoundingBox",
  id: "filter-7"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  in: "SourceAlpha",
  result: "shadowBlurInner1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.768627451   0 0 0 0 0.396078431   0 0 0 0 0.00392156863  0 0 0 1 0",
  type: "matrix",
  in: "shadowInnerInner1",
  result: "shadowMatrixInner1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5,
  in: "SourceAlpha",
  result: "shadowBlurInner2"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "shadowBlurInner2",
  result: "shadowOffsetInner2"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner2",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
  type: "matrix",
  in: "shadowInnerInner2",
  result: "shadowMatrixInner2"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixInner1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixInner2"
}))), /*#__PURE__*/React.createElement("path", {
  d: "M52.1488235,91.4488889 C48.2829218,84.3814461 45.35,76.9485575 45.35,69.15 C45.35,61.3514425 48.2829218,53.9185539 52.1488235,46.8511111 C52.6229435,46.0503664 53.2611725,45.65 54.0635294,45.65 C54.5011787,45.65 54.8749984,45.7892579 55.185,46.0677778 C55.4950015,46.3462977 55.65,46.6944424 55.65,47.1122222 C55.65,47.3559271 55.5952947,47.6170356 55.4858824,47.8955556 C52.4223376,54.7889234 49.8905882,61.8736673 49.8905882,69.15 C49.8905882,76.4263327 52.4223376,83.5110766 55.4858824,90.4044444 C55.5952947,90.7177793 55.65,90.9788878 55.65,91.1877778 C55.65,91.6403726 55.4950016,91.9972209 55.185,92.2583333 C54.8749985,92.5194457 54.5011787,92.65 54.0635294,92.65 C53.2611725,92.65 52.6229435,92.2496336 52.1488235,91.4488889 Z",
  id: "path-8"
}), /*#__PURE__*/React.createElement("filter", {
  x: "-19.4%",
  y: "-4.3%",
  width: "138.8%",
  height: "108.5%",
  filterUnits: "objectBoundingBox",
  id: "filter-9"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  in: "SourceAlpha",
  result: "shadowBlurInner1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.441039741   0 0 0 0 0.211583197   0 0 0 0 0  0 0 0 1 0",
  type: "matrix",
  in: "shadowInnerInner1",
  result: "shadowMatrixInner1"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 1,
  operator: "erode",
  in: "SourceAlpha",
  result: "shadowSpreadInner2"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5,
  in: "shadowSpreadInner2",
  result: "shadowBlurInner2"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "shadowBlurInner2",
  result: "shadowOffsetInner2"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner2",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
  type: "matrix",
  in: "shadowInnerInner2",
  result: "shadowMatrixInner2"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixInner1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixInner2"
}))), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "78.0565617%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "linearGradient-10"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#545454",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#000000",
  offset: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "cool",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Oval-Copy"
}, /*#__PURE__*/React.createElement("use", {
  fill: "url(#linearGradient-1)",
  fillRule: "evenodd",
  xlinkHref: "#path-2"
}), /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-3)",
  xlinkHref: "#path-2"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(29.000000, 30.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Oval",
  fill: "black",
  fillOpacity: 1
}, /*#__PURE__*/React.createElement("use", {
  filter: "url(#filter-5)",
  xlinkHref: "#path-4"
})), /*#__PURE__*/React.createElement("g", {
  id: "Oval-Copy-2"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#FD9B0A",
  fillRule: "evenodd",
  xlinkHref: "#path-6"
}), /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-7)",
  xlinkHref: "#path-6"
}))), /*#__PURE__*/React.createElement("g", {
  id: "(",
  transform: "translate(50.500000, 69.150000) rotate(-90.000000) translate(-50.500000, -69.150000) "
}, /*#__PURE__*/React.createElement("use", {
  fill: "#BF7608",
  fillRule: "evenodd",
  xlinkHref: "#path-8"
}), /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-9)",
  xlinkHref: "#path-8"
})), /*#__PURE__*/React.createElement("g", {
  id: "black-sunglasses-copy-2",
  transform: "translate(10.000000, 25.000000)",
  stroke: "#000000"
}, /*#__PURE__*/React.createElement("path", {
  d: "M63.7484083,0.000413199896 C57.2520218,0.0443742147 50.9916497,2.0955913 44.6151575,2.91576406 C41.9537714,3.25823022 39.2109023,3.34211082 36.5450782,3.02386343 C33.0007033,2.60043247 29.569122,1.47614231 26.0269763,0.972198016 C22.8615944,0.52207745 19.6564771,0.0517730428 16.4711172,0.0329339535 C10.9045627,-0.000257606247 5.5207358,1.76029812 0.0636376154,2.71077638 C0.0636376154,4.32331316 -0.260737329,6.39292101 0.555196986,7.52640644 C1.39688505,8.69532842 2.81649775,9.76444629 3.18483252,11.3485004 C4.05804759,15.1055528 5.29782568,18.7881424 6.88306754,22.3186784 C7.65348321,24.0343798 9.10751232,25.2306653 10.7311652,26.0546537 C14.6409817,28.0388101 19.2686015,28.3305906 23.5578614,27.7066617 C29.6661484,26.8180833 32.9800581,22.188376 35.5082293,16.8984032 C36.4544885,14.7480598 36.5601744,12.2664577 37.8063891,10.3011336 C38.5466093,9.13400828 40.2655101,9.62517092 41.4939662,9.62091015 C42.7224155,9.6166496 43.7637025,11.6806519 44.144911,13.0545544 C45.4941487,17.916613 47.7439039,23.0751609 52.214997,25.6226942 C58.8918853,29.4270718 69.4106512,28.7154467 73.7427635,21.8544274 C75.4381257,19.1691861 75.9063736,15.9111432 76.7569412,12.8710989 C77.2746984,11.0201604 77.7373901,8.81374488 79.5788478,7.79620911 C80.3219544,7.3855598 79.8004233,5.74700758 79.9101065,4.79451355 C80.029777,3.75679394 80.2602421,2.83883643 78.7984413,2.63519373 C76.2489542,2.27949401 73.7758418,1.19804259 71.1666279,0.832025324 C68.6939626,0.485072769 66.2712535,-0.0164076398 63.7484083,0.000412302797 L63.7484083,0.000413199896 Z M20.8001163,1.72800322 C22.6442333,1.71634047 24.4805824,1.85270004 26.2729779,2.23553725 C36.9522645,4.51731227 37.1682974,8.96199012 32.7718035,18.1509768 C29.189465,25.6386215 21.7683555,27.5146786 14.2906327,25.7198088 C10.843508,24.8926858 8.48651571,22.4619918 7.37484716,19.1335277 C6.2014563,15.6204859 5.31403289,11.8881037 5.51496321,8.19564131 C5.78405251,3.25127972 11.3204117,2.55647459 15.2846261,2.1059057 C17.1036599,1.89935079 18.9562162,1.73989158 20.8001163,1.72800299 L20.8001163,1.72800322 Z M59.7935206,1.72800322 C61.6376411,1.7398918 63.4899736,1.89935101 65.3090041,2.10590593 C69.2732218,2.55647482 74.8098046,3.25127994 75.0786736,8.19564154 C75.279604,11.8881042 74.3921772,15.6204861 73.2187864,19.133528 C72.1071211,22.461992 69.7501288,24.892686 66.3030041,25.719809 C58.825498,27.5146788 51.4043919,25.6386215 47.8218298,18.1509771 C43.4253359,8.96199035 43.6413691,4.51731249 54.320879,2.23553748 C56.1132678,1.85270004 57.9494,1.7163407 59.7935203,1.72800344 L59.7935206,1.72800322 Z",
  id: "path2830",
  fill: "#222222",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.9953171,1.41953639 C18.6817998,1.00176592 22.4967408,0.775764352 26.1292345,1.54987632 C36.9506495,3.85611098 37.1688779,8.34889701 32.7140985,17.6364028 C29.0838638,25.2043159 21.5680357,27.100943 13.9907933,25.2870586 C10.4977915,24.4508326 8.10808129,21.9854736 6.98161778,18.6213247 C5.7926105,15.0706194 4.88842639,11.3002629 5.09203085,7.56843801 C5.36447844,2.57083937 10.9783438,1.87470736 14.9953171,1.41953616 L14.9953171,1.41953639 Z",
  id: "path2832",
  fill: "url(#linearGradient-10)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.0047406,1.41953639 C61.3180558,1.00176592 57.5033592,0.775764352 53.8706664,1.54987632 C43.0493055,3.85611098 42.8310783,8.34889701 47.2860592,17.6364028 C50.9160539,25.2043159 58.4320593,27.100943 66.0090393,25.2870586 C69.5020214,24.4508326 71.8919413,21.9854736 73.0184019,18.6213247 C74.2071759,15.0706194 75.1115781,11.3002629 74.9079748,7.56843801 C74.6353022,2.57083937 69.021695,1.87470736 65.0047409,1.41953616 L65.0047406,1.41953639 Z",
  id: "path2832-1",
  fill: "url(#linearGradient-10)"
})));

var SvgCool = function SvgCool(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCool, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cool.21575853.svg";
export { ForwardRef as ReactComponent };